import { BookingData } from "../../AppDataProvider/types";

export const getWidgetType = (
  bookingData: BookingData,
  inPopoverMode?: boolean,
) => {
  if (bookingData.createdSource === "microsite") return "BOOKING_PAGE";
  if (bookingData.createdSource === "microsite_app") return "WIDGET_URL";
  if (bookingData.createdSource === "npm_location_search")
    return "NPM_LOCATION_SEARCH";
  if (inPopoverMode) return "POPOVER";
  return "EMBEDDED";
};
